import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const DraggableIcon = withSvgIcon(
    <g>
        <path d="M59.7 189.2L-.6 249.4l60.8 60.8 12.5-12.4-39.5-39.6h156.7v-17.6H33.2l38.9-38.9zM309.9 59.5L249.6-.8 188.8 60l12.5 12.5L240.8 33v156.7h17.6V33l39 39zM439.6 309.7l60.2-60.3-60.8-60.8-12.4 12.5 39.5 39.5H309.4v17.6h156.7l-39 39zM189.4 439.4l60.2 60.2 60.8-60.8-12.4-12.4-39.6 39.5V309.2h-17.6v156.7l-39-39z" />
    </g>
);
